import React from 'react'
import {View} from 'react-native'
import {msg, Trans} from '@lingui/macro'
import {useLingui} from '@lingui/react'

import {useLoggedOutViewControls} from '#/state/shell/logged-out'
import {useCloseAllActiveElements} from '#/state/util'
import {Link} from '#/view/com/util/Link'
import {Logotype} from '#/view/icons/Logotype'
import {atoms as a, useTheme, web} from '#/alf'
import {Button, ButtonText} from '#/components/Button'

export function LoggedOutHeader() {
  const {_} = useLingui()
  const t = useTheme()
  const {requestSwitchToAccount} = useLoggedOutViewControls()
  const closeAllActiveElements = useCloseAllActiveElements()

  const showSignIn = React.useCallback(() => {
    closeAllActiveElements()
    requestSwitchToAccount({requestedAccount: 'none'})
  }, [requestSwitchToAccount, closeAllActiveElements])

  return (
    <View
      style={[
        t.atoms.bg,
        t.atoms.border_contrast_low,
        web({
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          borderBottomWidth: 1,
          zIndex: 100,
          // Use CSS env() for iOS safe area - this works in PWA mode
          paddingTop: 'env(safe-area-inset-top, 0px)',
        } as any),
      ]}>
      <View
        style={[
          a.w_full,
          a.flex_row,
          a.align_center,
          a.justify_between,
          a.pt_md,
          a.pb_md,
          a.pl_md,
          a.pr_sm,
          a.gap_sm,
        ]}>
        <Link href="/" style={[a.flex_row, a.align_center]}>
          <Logotype width={130} />
        </Link>

        <View style={[a.flex_row, a.flex_wrap, a.gap_sm]}>
          <Button
            onPress={showSignIn}
            label={_(msg`Sign in`)}
            size="small"
            variant="solid"
            color="primary">
            <ButtonText>
              <Trans>Sign in</Trans>
            </ButtonText>
          </Button>
        </View>
      </View>
    </View>
  )
}
